import React, { useState } from "react";
import AnimatedPopup from "../common/AnimatedPopup";
import toast from "react-hot-toast";
import Checkbox from "../common/Checkbox";
import categorySearchWhite from "../../assets/icons/category_search-white.svg";

export default function CategoryManagement({
  openCategoryManagementPopup,
  setOpenCategoryManagementPopup,
}) {
  // ✅ States
  const [tabs, setTabs] = useState(["I3D", "WebGL", "홍보"]);
  const [devTechs, setDevTechs] = useState(["JavaScript", "Node.js"]);
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedTechs, setSelectedTechs] = useState([]);
  const [newTab, setNewTab] = useState("");
  const [newTech, setNewTech] = useState("");

  // ✅ Toggle checkbox for Tabs
  const handleTabToggle = (tab) => {
    setSelectedTabs((prev) =>
      prev.includes(tab) ? prev.filter((t) => t !== tab) : [...prev, tab]
    );
  };

  // ✅ Toggle checkbox for Developer Technologies
  const handleTechToggle = (tech) => {
    setSelectedTechs((prev) =>
      prev.includes(tech) ? prev.filter((t) => t !== tech) : [...prev, tech]
    );
  };

  // ✅ Delete selected Tabs
  const handleDeleteSelectedTabs = () => {
    if (selectedTabs.length === 0) return;
    setTabs((prev) => prev.filter((tab) => !selectedTabs.includes(tab)));
    setSelectedTabs([]);
    toast.success("선택된 탭이 삭제되었습니다!");
  };

  // ✅ Delete selected Developer Technologies
  const handleDeleteSelectedTechs = () => {
    if (selectedTechs.length === 0) return;
    setDevTechs((prev) => prev.filter((tech) => !selectedTechs.includes(tech)));
    setSelectedTechs([]);
    toast.success("선택된 개발 기술이 삭제되었습니다!");
  };

  // ✅ Add new Tab
  const handleAddTab = () => {
    const trimmed = newTab.trim();
    if (!trimmed) return toast.error("탭 이름을 입력해주세요.");
    if (tabs.includes(trimmed)) return toast.error("이미 존재하는 탭입니다.");
    setTabs((prev) => [...prev, trimmed]);
    setNewTab("");
    toast.success("새로운 탭이 추가되었습니다!");
  };

  // ✅ Add new Developer Technology
  const handleAddTech = () => {
    const trimmed = newTech.trim();
    if (!trimmed) return toast.error("개발 기술 이름을 입력해주세요.");
    if (devTechs.includes(trimmed))
      return toast.error("이미 존재하는 기술입니다.");
    setDevTechs((prev) => [...prev, trimmed]);
    setNewTech("");
    toast.success("새로운 개발 기술이 추가되었습니다!");
  };

  return (
    <AnimatedPopup
      label="카테고리 관리"
      isOpen={openCategoryManagementPopup}
      onClose={() => setOpenCategoryManagementPopup(false)}
      className="max-w-[1320px]"
      icon={categorySearchWhite}
    >
      <div className="p-4 sm:p-10 bg-white grid grid-cols-1 md:grid-cols-2 gap-5 gap-y-14 lg:gap-5 2xl:h-[600px] h-[500px] overflow-y-auto md:overflow-hidden">
        {/* ================= Tabs Section ================= */}
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between">
            <h5 className="text-[#242424] font-normal md:text-[20px] text-[16px]">
              탭
            </h5>
            <button
              onClick={handleDeleteSelectedTabs}
              disabled={selectedTabs.length === 0}
              className={`w-10 aspect-square rounded-[10px] flex items-center justify-center ${
                selectedTabs.length === 0
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#08F]"
              }`}
            >
              <TrashIcon />
            </button>
          </div>

          <div className="flex-1 flex flex-col overflow-hidden max-h-[400px]">
            <div className="flex-1 p-5 border border-[#BABABA] rounded-[20px] flex flex-col gap-2.5 overflow-y-auto">
              {tabs.map((tab, idx) => {
                const checked = selectedTabs.includes(tab);
                return (
                  <div
                    key={idx}
                    onClick={() => handleTabToggle(tab)}
                    className={`flex items-center justify-between px-5 lg:py-[15px] py-[10px] rounded-[10px] border border-[#BABABA] cursor-pointer text-[#242424] text-[16px] ${
                      checked ? "bg-[#EDF0FB]" : ""
                    }`}
                  >
                    <Checkbox
                      checked={checked}
                      onChange={() => handleTabToggle(tab)}
                      color="#242424"
                      borderColor="border-[#242424]"
                    />
                    <p>{tab}</p>
                    <span className="opacity-0">
                      <Checkbox />
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Add New Tab */}
          <div className="flex items-center gap-2.5 justify-end">
            <input
              type="text"
              value={newTab}
              onChange={(e) => setNewTab(e.target.value)}
              placeholder="탭 이름을 입력해 주세요."
              className="px-4 py-2 border border-[#BABABA] rounded-[10px] bg-transparent outline-none w-full max-w-[302px] text-[#242424] placeholder:text-[#C9C9C9]"
            />
            <button
              onClick={handleAddTab}
              className="bg-[#08F] rounded-[10px] px-4 py-[9px] text-white min-w-[102px]"
            >
              저장
            </button>
          </div>
        </div>

        {/* ================= Developer Technologies Section ================= */}
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between">
            <h5 className="text-[#242424] font-normal md:text-[20px] text-[16px]">
              개발 기술
            </h5>
            <button
              onClick={handleDeleteSelectedTechs}
              disabled={selectedTechs.length === 0}
              className={`w-10 aspect-square rounded-[10px] flex items-center justify-center ${
                selectedTechs.length === 0
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#08F]"
              }`}
            >
              <TrashIcon />
            </button>
          </div>

          <div className="flex-1 flex flex-col overflow-hidden max-h-[400px]">
            <div className="flex-1 p-5 border border-[#BABABA] rounded-[20px] flex flex-col gap-2.5 overflow-y-auto">
              {devTechs.map((tech, idx) => {
                const checked = selectedTechs.includes(tech);
                return (
                  <div
                    key={idx}
                    onClick={() => handleTechToggle(tech)}
                    className={`flex items-center justify-between px-5 lg:py-[15px] py-[10px] rounded-[10px] border border-[#BABABA] cursor-pointer text-[#242424] text-[16px] ${
                      checked ? "bg-[#EDF0FB]" : ""
                    }`}
                  >
                    <Checkbox
                      checked={checked}
                      onChange={() => handleTechToggle(tech)}
                      color="#242424"
                      borderColor="border-[#242424]"
                    />
                    <p>{tech}</p>
                    <span className="opacity-0">
                      <Checkbox />
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Add New Tech */}
          <div className="flex items-center gap-2.5 justify-end">
            <input
              type="text"
              value={newTech}
              onChange={(e) => setNewTech(e.target.value)}
              placeholder="개발 기술 이름을 입력해 주세요."
              className="px-4 py-2 border border-[#BABABA] rounded-[10px] bg-transparent outline-none w-full max-w-[302px] text-[#242424] placeholder:text-[#C9C9C9]"
            />
            <button
              onClick={handleAddTech}
              className="bg-[#08F] rounded-[10px] px-4 py-[9px] text-white min-w-[102px]"
            >
              저장
            </button>
          </div>
        </div>
      </div>
    </AnimatedPopup>
  );
}

// ✅ Reusable Trash Icon
const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M2.6155 16C2.168 16 1.78683 15.8426 1.472 15.528C1.15733 15.2131 1 14.832 1 14.3845V1.99996H0V0.999963H4V0.230713H10V0.999963H14V1.99996H13V14.3845C13 14.8448 12.8458 15.2291 12.5375 15.5375C12.2292 15.8458 11.8448 16 11.3845 16H2.6155ZM12 1.99996H2V14.3845C2 14.564 2.05767 14.7115 2.173 14.827C2.2885 14.9423 2.436 15 2.6155 15H11.3845C11.5385 15 11.6796 14.9359 11.8077 14.8077C11.9359 14.6795 12 14.5385 12 14.3845V1.99996ZM4.80775 13H5.80775V3.99996H4.80775V13ZM8.19225 13H9.19225V3.99996H8.19225V13Z"
      fill="white"
    />
  </svg>
);
